export default "__VITE_ASSET__DdGdR4P7__"